import { Field, FieldProps as FormikFieldProps } from 'formik'

import { FieldProps } from '../types'
import { Checkbox } from 'components/Input'

interface CheckboxDrawerProps extends FormikFieldProps {
  labelText?: string
  disabled?: boolean
  checked?: boolean
}

function CheckboxDrawer({
  field,
  labelText,
  disabled = false,
  checked,
}: CheckboxDrawerProps) {
  return (
    <Checkbox
      {...field}
      labelText={labelText}
      checked={checked !== undefined ? checked : field.value}
      disabled={disabled}
    />
  )
}

function CheckboxField(props: FieldProps) {
  return <Field component={CheckboxDrawer} {...props} />
}

export default CheckboxField
